import { Theme } from "@mui/material";
import { IFormTextField } from "../../../services/custom-forms-data-service/TemplateModels";
import FormInput from "../../forms/form-input/FormInput";
import FormProperty from "../../forms/form-property/FormProperty";
import { SxProps } from "@mui/system";

export type CustomFormTextFieldProps = {
    textField: IFormTextField;
    key?: React.Key | null | undefined;
    sx?: SxProps<Theme>;
};

export default function CustomFormTextField({
    textField,
    key,
    sx
}: CustomFormTextFieldProps) {

     return (

        <FormProperty key={key} sx={sx}>
            <FormInput
                    id={textField.id}
                    name={textField.name}
                    ariaLabel={textField.ariaLabel}
                    label={textField.label}
                    // rules={{
                    //     pattern: {
                    //         value: /^[A-Za-z0-9+_-][A-Za-z0-9.+_-]{0,63}@[A-Za-z0-9.-]{1,61}\.[A-Za-z]{2,}$/,
                    //         message: t('profile.invalidEmail')
                    //     },
                    //     required: true
                    // }}
                    multiline={textField.multiline}
                    rows={textField.rows}
                    rules={textField.rules}
                    helperText={textField.helperText ?? ' '}
                    readOnly={textField.readOnly}
                    numeric={textField.numeric}
                    decimals={textField.decimals}
                    sx={{width: '100%'}}
                />
        </FormProperty>
    );
}
